const MONTHS = [
  'Janeiro',
  'Fevereiro',
  'Março',
  'Abril',
  'Maio',
  'Junho',
  'Julho',
  'Agosto',
  'Setembro',
  'Outubro',
  'Novembro',
  'Dezembro'
];

/**
 * Accepts a calendar day and rejects values such as month 13.
 */
function isCalendarDay(year, month, day) {
  if (month < 1 || month > 12 || day < 1 || day > 31) return false;
  const date = new Date(Date.UTC(year, month - 1, day));
  return date.getUTCFullYear() === year && date.getUTCMonth() + 1 === month && date.getUTCDate() === day;
}

/**
 * Reads the reference month from the first day of aaaammdd_aaaammdd in the file name.
 * Names that glue the same interval, or use a DDMMYY pair, use that first day as well.
 */
export function referencePeriodFromName(fileName) {
  const name = String(fileName || '');
  const ranged = name.match(/(20\d{2})(\d{2})(\d{2})_(20\d{2})(\d{2})(\d{2})/);
  if (ranged && isCalendarDay(Number(ranged[1]), Number(ranged[2]), Number(ranged[3]))) {
    return { year: Number(ranged[1]), month: Number(ranged[2]) };
  }

  const glued = name.match(/(20\d{2})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/);
  if (glued && isCalendarDay(Number(glued[1]), Number(glued[2]), Number(glued[3]))) {
    return { year: Number(glued[1]), month: Number(glued[2]) };
  }

  const dayFirst = name.match(/(?:^|[^0-9])(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})(?:[^0-9]|$)/);
  if (dayFirst) {
    const year = 2000 + Number(dayFirst[3]);
    const month = Number(dayFirst[2]);
    const day = Number(dayFirst[1]);
    if (isCalendarDay(year, month, day)) return { year, month };
  }

  return null;
}

/**
 * Groups processings by reference month, newest month first.
 */
export function groupByReferenceMonth(items, nameOf) {
  const groups = new Map();
  items.forEach((item) => {
    const period = referencePeriodFromName(nameOf(item));
    const key = period ? `${period.year}-${String(period.month).padStart(2, '0')}` : 'unknown';
    if (!groups.has(key)) {
      groups.set(key, {
        key,
        label: period ? `${MONTHS[period.month - 1]}/${period.year}` : 'Sem mês de referência',
        sort: period ? period.year * 100 + period.month : 0,
        items: []
      });
    }
    groups.get(key).items.push(item);
  });
  return Array.from(groups.values()).sort((left, right) => right.sort - left.sort);
}
